import PropTypes from "prop-types";
import { STATUS_MARKERS } from "./statusPillTokens";
import { StatusPillRoot } from "./StatusPill.styles";

const StatusPill = ({ label, tone = "neutral", showMarker = true }) => {
  const marker = showMarker ? STATUS_MARKERS[tone] || STATUS_MARKERS.neutral : "";
  return (
    <StatusPillRoot $tone={tone}>
      {marker}
      {label}
    </StatusPillRoot>
  );
};

StatusPill.propTypes = {
  label: PropTypes.node.isRequired,
  tone: PropTypes.oneOf(["ok", "warn", "crit", "info", "neutral"]),
  showMarker: PropTypes.bool,
};

StatusPill.defaultProps = {
  tone: "neutral",
  showMarker: true,
};

export default StatusPill;
